<h1 mat-dialog-title>{{ 'DELETE-ALL-PINS-DIALOG.DELETE-TITLE' | translate }}</h1>
<div mat-dialog-content>
    <p>{{ 'DELETE-ALL-PINS-DIALOG.DELETE-MESSAGE' | translate }}</p>
</div>
<div mat-dialog-actions>
    <button  class="delete-all-pin-btn" mat-flat-button (click)="deleteAllPins()">{{ 'DELETE-ALL-PINS-DIALOG.YES' | translate }}</button>
    <button  class="delete-all-pin-btn" mat-flat-button (click)="cancel()">{{ 'DELETE-ALL-PINS-DIALOG.NO' | translate }}</button>
</div>
